export default __webpack_public_path__ + "static/media/myjourney-smallbluetree.eb763fa2.svg";